import React, { useContext } from "react";

import MediaCardSection from "./MediaCardSection";

export default function FastPracticeMediaCardSection(props) {
	const { additionalData } = props;

	//this should be one fast practice product with 3 variants
	if (!additionalData?.fastPracticeData?.items?.length) return <>No Fast Practice Products</>;
	const productData = additionalData?.fastPracticeData?.items[0].fields;

	const { productId, productMedia, description, shortDescription, productType } = productData;
	const variantData = productData.variants.map((variant) => {
		variant.fields = {
			...variant.fields,
			productMedia: productMedia[0],
			description: description,
			shortDescription: shortDescription,
			productId,
			productType,
		};
		return {
			...variant,
		};
	});
	return (
		<MediaCardSection
			data={{
				fields: { columnCount: 1, isContainer: "md", mediaCards: variantData },
			}}
		/>
	);
}
